import { useSyncedRef } from "@react-hookz/web";
import { useCookieValue } from "@react-hookz/web/cjs/useCookieValue";
import { getUnixTime } from "date-fns";
import React, { useEffect } from "react";
import { useSdkContext } from "~/components/contexts";
import { useFallbackStorageValue } from "~/lib/hooks";
import { useControlledPromise } from "~/lib/utils";
import { LoginReminderTooltip } from "./component";
export const useLoginReminderTooltipRender = () => {
  const {
    hasAcceptedGDPR,
    user
  } = useSdkContext();

  // The value is set by account sdk: https://project.scmp.tech/search?scope=blobs&search=last_logout_timestamp
  const [lastLogoutTimestamp] = useCookieValue("last_logout_timestamp");
  const {
    remove: removeReminderState,
    set: setReminderState,
    value: reminderState
  } = useFallbackStorageValue("loginReminderData");
  const syncedReminderState = useSyncedRef(reminderState);

  // Reset the data when user has logged in
  useEffect(() => {
    if (user) {
      removeReminderState();
    }
  }, [removeReminderState, user]);
  const {
    promise,
    reject,
    resolve
  } = useControlledPromise();
  useEffect(() => {
    var _syncedReminderState$;
    if (!hasAcceptedGDPR || lastLogoutTimestamp === null || user) return reject.current();
    const reminderState = (_syncedReminderState$ = syncedReminderState.current) !== null && _syncedReminderState$ !== void 0 ? _syncedReminderState$ : [{
      // 30 minutes
      intervalTime: 1800,
      shown: false
    }, {
      // 1 day
      intervalTime: 86_400,
      shown: false
    }, {
      // 30 days
      intervalTime: 172_800,
      shown: false
    }];
    const currentUnixTime = getUnixTime(new Date());
    const parsedLastLogoutTimestamp = Number.parseInt(lastLogoutTimestamp !== null && lastLogoutTimestamp !== void 0 ? lastLogoutTimestamp : "0");
    for (const [index, state] of reminderState.entries()) {
      if (currentUnixTime - parsedLastLogoutTimestamp >= state.intervalTime && !state.shown) {
        return resolve.current({
          node: /*#__PURE__*/React.createElement(LoginReminderTooltip, {
            onImpression: () => {
              setReminderState(() => {
                reminderState[index].shown = true;
                return reminderState;
              });
            }
          })
        });
      }
    }
    return reject.current();
  }, [lastLogoutTimestamp, reject, resolve, setReminderState, syncedReminderState, hasAcceptedGDPR, user]);
  return {
    loginReminderTooltipRender: promise
  };
};